import { render, staticRenderFns } from "./product-mateial-detail-dialog.vue?vue&type=template&id=558e8eba&scoped=true"
import script from "./product-mateial-detail-dialog.vue?vue&type=script&lang=js"
export * from "./product-mateial-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./product-mateial-detail-dialog.vue?vue&type=style&index=0&id=558e8eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e8eba",
  null
  
)

export default component.exports